<router-outlet></router-outlet>
<p-toast position="bottom-left" [baseZIndex]="1002"></p-toast>
<p-confirmDialog [style]="{'min-width': '40vw'}" [acceptLabel]="'Sim'" [rejectLabel]="'Não'"></p-confirmDialog>